import CarrotIcon from './carrot-icon';
export default CarrotIcon;
